import React, { useState } from 'react';
import InitialResponse from '../pages/login/InitialResponse';
import SaveLastPath from '../pages/login/SaveLastPath';
import SessionExpiredModal from '../pages/login/SessionExpiredModal';
import LeftSection from './LeftSection';
import RightSection from './RightSection';
import Loading from './Loading';
import SidebarToggle from './SidebarToggle';
import { useSidebarStore } from '../../store/useSidebar';

/**
 * @author taulmax
 * @date 2024.09.27
 * @description 전체 레이아웃 컴포넌트
 */
const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { isVisible } = useSidebarStore();
  
  return (
  <div 
    className="!flex !flex-col md:!flex-row !h-screen !bg-gray-50 !overflow-hidden"
    style={{
      '--sidebar-width': isVisible ? '256px' : '0px',
    } as React.CSSProperties}
  >
      <SaveLastPath /> {/* 경로 저장 컴포넌트 */}
      <SessionExpiredModal /> {/* 로그인 세션 만료 컴포넌트 */}
      <InitialResponse /> {/* 로그인 했을때 처음에 가져와야 하는 데이터 */}

      {/* 데스크톱용 사이드바 토글 버튼 */}
      <div className="!hidden md:!block">
        <SidebarToggle />
      </div>

      {/* 모바일 햄버거 버튼 */}
      <button
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        className="md:!hidden !fixed !top-4 !left-4 !z-[60] !bg-blue-500 !text-white !p-2 !rounded-md"
      >
        <svg className="!w-6 !h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isSidebarOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
        </svg>
      </button>

      {/* 사이드바 */}
      <div className={`
        ${isSidebarOpen ? '!block' : '!hidden'}
        md:!block
        md:!flex-shrink-0
        !transition-all !duration-300 !ease-in-out
        ${isVisible ? 'md:!w-64 md:!opacity-100' : 'md:!w-0 md:!opacity-0'}
        !overflow-hidden
        !fixed md:!relative !inset-0 !z-50 md:!z-auto !w-64
      `}>
          <LeftSection />
      </div>

      {/* 모바일 오버레이 */}
      {isSidebarOpen && (
        <div
          className="md:!hidden !fixed !inset-0 !bg-black !bg-opacity-50 !z-40"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}
      
      {/* 메인 콘텐츠 */}
      <div className={`
        !flex-1 !flex !flex-col !min-h-0 !w-full
        !transition-all !duration-300 !ease-in-out
      `}>
          <RightSection />
      </div>
      
      <Loading />
    </div>
  );
};

export default React.memo(Layout);
